import React, { useEffect, useState } from "react";

import ErrorBoundary from "src/components/Common/ErrorBoundary";
import usersApi from "apis/users";
import { logout } from "apis/authentication";

import Main from "components/Main";
import { FeaturesProvider } from "contexts/features";
import ThemeProvider from "contexts/ThemeProvider";
import { UserProvider } from "contexts/user";
import Cookies from "js-cookie";

const App = () => {
  // const currentEnvironment = process.env.CS_ENV ?? "production";
  // const features = getCurrentEnvironmentFeatures(currentEnvironment);
  const [user, setUser] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  console.log("url", process.env.CSB_BASE_URL);

  const getUser = async () => {
    try {
      setIsLoading(true);
      const { data } = await usersApi.getCurrentUser();
      setUser({
        user: data?.current_user,
        organization_logo_url: data?.organization_logo_url,
        features: data?.features,
        is_development_or_heroku_environment:
          data?.is_development_or_heroku_environment,
      });
    } catch (error) {
      // TODO: remove console.log
      console.log(error);
      logger.error(error);
      localStorage.clear();
      logout();
      // window.location.href = "/login";
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("user") || localStorage.getItem("managementToken")) {
      getUser();
    } else {
      const sessionToken = Cookies.get("_csb_session");
      if (sessionToken) {
        localStorage.setItem("managementToken", sessionToken);
        getUser();
      }
    }
  }, []);

  return (
    <UserProvider>
      <FeaturesProvider>
        <ErrorBoundary>
          <ThemeProvider>
            {!isLoading && (
              <Main
                user={user?.user}
                organization_logo_url={user?.organization_logo_url}
                features={user?.features}
                // is_development_or_heroku_environment={
                //   user?.is_development_or_heroku_environment
                // }
              />
            )}
          </ThemeProvider>
        </ErrorBoundary>
      </FeaturesProvider>
    </UserProvider>
  );
};

export default App;
